import { TYPES } from "../../common/constants";
import { createReducer } from "@reduxjs/toolkit";
const fetchCustomerFeedReportsDone = (_, { payload }) => {
    return [
      ...payload
    ];
  };
const clearReportsDone= () => {
    return initialState
  }
const initialState = [];
export default createReducer(initialState, {
  [TYPES.FETCH_CUSTOMER_FEEDBACK_DONE]: fetchCustomerFeedReportsDone,
  [TYPES.CLEAR_REPORTS_DONE]: clearReportsDone
});
